import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _approveGroupRequestsRequest = {};
var _approveGroupRequestsResponse = { groupRequest: '_groupRequest' };
var _cancelGroupRequestRequest = {};
var _cancelGroupRequestResponse = { groupRequest: '_groupRequest' };
var _coverImage = {
    position: '_coverImagePosition',
    mobilePosition: '_coverImagePosition',
};
var _coverImagePosition = { x: 'FLOAT', y: 'FLOAT' };
var _group = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    recentActivityDate: 'google.protobuf.Timestamp',
    lastActivityDate: 'google.protobuf.Timestamp',
    details: '_groupDetails',
    coverImage: '_coverImage',
};
var _groupDetails = {
    logoPosition: '_position',
    mobileLogoPosition: '_position',
};
var _groupRequest = { group: '_group' };
var _listGroupRequestsRequest = {};
var _listGroupRequestsResponse = { groupRequests: '_groupRequest' };
var _position = { x: 'FLOAT', y: 'FLOAT' };
var _queryGroupRequestsRequest = {};
var _queryGroupRequestsResponse = { groupRequests: '_groupRequest' };
var _rejectGroupRequestsRequest = {};
var _rejectGroupRequestsResponse = { groupRequest: '_groupRequest' };
var _submitGroupRequestRequest = { group: '_group' };
var _submitGroupRequestResponse = { groupRequest: '_groupRequest' };
function resolveWixSocialGroupsApiV2GroupRequestsServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/social-groups-proxy/group-requests',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/group-requests-proxy',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Submit a group request.
 * Can be used in case `GroupsAppSettings.create_groups_policy` = `MEMBERS_WITH_APPROVAL`.
 * This endpoint doesn't support server signing.
 */
export function submitGroupRequest(payload) {
    var _a = serializer(_submitGroupRequestRequest, { _coverImage: _coverImage, _coverImagePosition: _coverImagePosition, _group: _group, _groupDetails: _groupDetails, _position: _position }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submitGroupRequestResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _groupRequest: _groupRequest,
        _position: _position,
    }).fromJSON;
    function __submitGroupRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupRequestsService.SubmitGroupRequest',
            url: resolveWixSocialGroupsApiV2GroupRequestsServiceUrl({
                protoPath: '/v2/groups-requests',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __submitGroupRequest.fromReq = fromReq;
    __submitGroupRequest.__isAmbassador = true;
    return __submitGroupRequest;
}
/**
 * Approves Group Requests.
 * Only admins can approve Group Requests.
 */
export function approveGroupRequests(payload) {
    var _a = serializer(_approveGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_approveGroupRequestsResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _groupRequest: _groupRequest,
        _position: _position,
    }).fromJSON;
    function __approveGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupRequestsService.ApproveGroupRequests',
            url: resolveWixSocialGroupsApiV2GroupRequestsServiceUrl({
                protoPath: '/v2/group-requests/approve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __approveGroupRequests.fromReq = fromReq;
    __approveGroupRequests.__isAmbassador = true;
    return __approveGroupRequests;
}
/**
 * Rejects Group Requests.
 * Only admins can reject Group Requests.
 */
export function rejectGroupRequests(payload) {
    var _a = serializer(_rejectGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rejectGroupRequestsResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _groupRequest: _groupRequest,
        _position: _position,
    }).fromJSON;
    function __rejectGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupRequestsService.RejectGroupRequests',
            url: resolveWixSocialGroupsApiV2GroupRequestsServiceUrl({
                protoPath: '/v2/group-requests/reject',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rejectGroupRequests.fromReq = fromReq;
    __rejectGroupRequests.__isAmbassador = true;
    return __rejectGroupRequests;
}
/**
 * Cancels a Group Request.
 * Group managers always have access to this functionality. Site members can cancel their own group requests.
 * This endpoint doesn't support server signing.
 */
export function cancelGroupRequest(payload) {
    var _a = serializer(_cancelGroupRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelGroupRequestResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _groupRequest: _groupRequest,
        _position: _position,
    }).fromJSON;
    function __cancelGroupRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_request',
            method: 'DELETE',
            methodFqn: 'wix.social.groups.api.v2.GroupRequestsService.CancelGroupRequest',
            url: resolveWixSocialGroupsApiV2GroupRequestsServiceUrl({
                protoPath: '/v2/group-requests/{groupRequestId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelGroupRequest.fromReq = fromReq;
    __cancelGroupRequest.__isAmbassador = true;
    return __cancelGroupRequest;
}
/** Lists group requests across the site. */
export function listGroupRequests(payload) {
    var _a = serializer(_listGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listGroupRequestsResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _groupRequest: _groupRequest,
        _position: _position,
    }).fromJSON;
    function __listGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_request',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.GroupRequestsService.ListGroupRequests',
            url: resolveWixSocialGroupsApiV2GroupRequestsServiceUrl({
                protoPath: '/v2/group-requests',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGroupRequests.fromReq = fromReq;
    __listGroupRequests.__isAmbassador = true;
    return __listGroupRequests;
}
/**
 * Retrieves a list of groups requests across the site.
 *
 * Supported fields for filtering:
 * - `status`
 *
 * Supported fields for sorting:
 * - `createdDate`
 */
export function queryGroupRequests(payload) {
    var _a = serializer(_queryGroupRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryGroupRequestsResponse, {
        _coverImage: _coverImage,
        _coverImagePosition: _coverImagePosition,
        _group: _group,
        _groupDetails: _groupDetails,
        _groupRequest: _groupRequest,
        _position: _position,
    }).fromJSON;
    function __queryGroupRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.group_request',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.GroupRequestsService.QueryGroupRequests',
            url: resolveWixSocialGroupsApiV2GroupRequestsServiceUrl({
                protoPath: '/v2/group-requests/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryGroupRequests.fromReq = fromReq;
    __queryGroupRequests.__isAmbassador = true;
    return __queryGroupRequests;
}
//# sourceMappingURL=http.impl.js.map